import {
  APP_LOCALES,
  DEFAULT_APP_LOCALE,
  isAppLocale,
  type AppLocale,
} from "./locales";

export type EnabledLocalesValidationError = "empty" | "missingEnglish" | "unsupported";

/**
 * Sanitize an untrusted settings response.
 *
 * English-only is the fail-closed fallback. Tenants that have never saved a
 * language list receive English, Greek, and Spanish from the settings API.
 */
export function normalizeEnabledLocales(value: unknown): AppLocale[] {
  if (!Array.isArray(value)) return [DEFAULT_APP_LOCALE];

  const enabled = new Set(
    value.filter((item): item is AppLocale => typeof item === "string" && isAppLocale(item)),
  );
  if (!enabled.has(DEFAULT_APP_LOCALE)) {
    return [DEFAULT_APP_LOCALE];
  }

  return APP_LOCALES.filter((locale) => enabled.has(locale));
}

export function validateEnabledLocales(
  value: readonly string[],
): EnabledLocalesValidationError | null {
  if (value.length === 0) return "empty";
  if (value.some((locale) => !isAppLocale(locale))) {
    return "unsupported";
  }
  if (!value.includes(DEFAULT_APP_LOCALE)) {
    return "missingEnglish";
  }
  return null;
}
